import React, { forwardRef } from "react";

export const QrPrintAssets = forwardRef(({ qrPrint }, ref) => {
    
	return (
        <div 
            ref={ ref }
            style={{  display: 'flex', flexWrap: 'wrap', margin: 25 }}
        >
            {
                qrPrint?.map(d => ( 
                    <div 
                        key={ d?._id } 
                        style={{ 
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center', 
                            alignItems: 'center', 
                            border: '1px dashed #000', 
                            padding: '3px 10px 0px 10px'
                        }}
                    >
                        <img src={ d?.img } alt="Qr" width={ 50 } height={ 50 } />
                        <span style={{ fontWeight: 600, fontSize: 10  }}>{d?.placa}</span>
                    </div>
                ))
            }
        </div>
    )
});